/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".video-container[_ngcontent-%COMP%]   .video[_ngcontent-%COMP%]{width:100%;height:500px;margin:0 auto 20px}@media only screen and (min-width:960px){.video-container[_ngcontent-%COMP%]   .video[_ngcontent-%COMP%]{width:900px}}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/downtown-life/our-view.component.scss.shim.ngstyle.js.pre-build-optimizer.js